import { Flex, Heading, List } from 'yoso';
import { Adventure, useAdventure } from '~/components/Adventure/Adventure.hooks';
import { AdventureControl } from '~/components/Adventure/Control/AdventureControl';
import { BaseCard } from '~/components/Card';
import { T } from '~/components/I18n';
import { useMembership } from '~/components/Membership/Membership.hooks';
import styles from './AdventureProgress.module.scss';
import { AdventureReward } from './AdventureReward';

export type AdventureProgressProps = Pick<Adventure, 'id'>;

export const AdventureProgress = ({ id }: AdventureProgressProps) => {
  const {
    data: { level },
  } = useMembership();
  const { data: { participation, milestoneList = [] } = {} } = useAdventure(id);
  const { currentCount = 0, maxCount = 12 } = participation || {};

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Heading level={5} className={styles.title}>
          <T name="citizen_adventure_join_num_my" />
        </Heading>
        <p className={styles.description}>
          <T name="citizen_adventure_join_num_desc" balance />
        </p>
      </div>
      <BaseCard className={styles.body} shadow size="large">
        <div className={styles.participation}>
          <p className={styles.participationTitle}>
            <T name="citizen_adventure_join_num_my2" />
          </p>
          <p className={styles.participationCount}>
            {currentCount} <span className={styles.trial}>/ {maxCount}</span>
          </p>
        </div>
        <Flex as={List} container justifyContent="center" className={styles.rewardList}>
          {milestoneList.map((each) => (
            <li key={`${level}-${each.count}`}>
              <AdventureReward
                rewarded={currentCount >= each.count}
                locked={each.level > level}
                {...each}
              />
            </li>
          ))}
        </Flex>
        <div className={styles.control}>
          <AdventureControl id={id} />
        </div>
      </BaseCard>
    </div>
  );
};
